import React, { useState, useEffect, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Headlessui for MODAL
import { Dialog, Transition } from '@headlessui/react'

//ICONS
import { BsFillCalendarWeekFill, BsFillExclamationTriangleFill, BsXLg } from "react-icons/bs";


//API
import kullanicilar from '../../services/kullanicilar';
import kullaniciCreate from '../../services/kullaniciCreate';
import kullaniciDelete from '../../services/kullaniciDelete';
import kullaniciUpdate from '../../services/kullaniciUpdate';

const KullaniciIslemleri = () => {

    let navigate = useNavigate();

    //Form Durum State 
    //false = yeni kayıt, true = düzenleme
    const [formDurum, setFormDurum] = useState(false)
    const [userId, setUserId] = useState(0)
    //MODAL State
    const [open, setOpen] = useState(false)

    //Form States
    const [adSoyad, setAdSoyad] = useState("")
    const [eposta, setEposta] = useState("")
    const [telefon, setTelefon] = useState("")
   // const [role, setRole] = useState("")


    //Form Verilerini kontrol et
    const handleValidation = () => {
        
        if (adSoyad === "") {
            document.getElementById('adSoyad').focus()
            return toast.error("Kullanıcı adı ve soyadı giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (eposta === "") {
            document.getElementById('eposta').focus()
            return toast.error("E-Posta adresi giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (telefon === "") {
            document.getElementById('telefon').focus()
            return toast.error("İletişim için telefon numarası giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (formDurum) {
            //Update
            handleKullaniciUpdate()
        } else {
            //Insert
            handleFormSave()
        }

    }

    //Formu Kaydet
    const handleFormSave = async () => {
        const data = {
            AdSoyad: adSoyad,
            email: eposta,
            dahili: telefon,
        }
        const result = await kullaniciCreate(data)
        if(result.data.errroStatus){
            toast.error(result.data.error, {
                position: toast.POSITION.TOP_CENTER
            });
        }else{
            toast.success("Kullanıcı Eklendi", {
                position: toast.POSITION.TOP_CENTER
            });
            getKullanicilar()
            clearForm()
        }
    }

    const handleKullaniciUpdate = async () => {
        const data = {
            AdSoyad: adSoyad,
            email: eposta,
            dahili: telefon,
        }
        const result = await kullaniciUpdate(userId, data)
        console.log(result.data)
        if (result) {
            toast.success("Kullanıcı Bilgileri Güncellendi", {
                position: toast.POSITION.TOP_CENTER
            });
            getKullanicilar()
            clearForm()
        }
    }

    const handleKullaniciDelete = async () => {
        const result = await kullaniciDelete(userId)
        if (result) {
            toast.success("Kullanıcı silindi", {
                position: toast.POSITION.TOP_CENTER
            });
            getKullanicilar()
            clearForm()
        }

    }

    const getKullaniciData = (id) => {
        setFormDurum(true)
        const result = kullaniciListesi.filter((item) => item.userId === id)
        if (result.length > 0) {
            setUserId(result[0].userId)
            setAdSoyad(result[0].AdSoyad)
            setEposta(result[0].email)
            setTelefon(result[0].dahili)
            //setRole(result[0].role)
        }
    }

    //Formu temizle
    const clearForm = () => {
        setFormDurum(false)
        setAdSoyad("")
        setEposta("")
        setTelefon("")
        //setRole("")
        setUserId(0)
        setOpen(false)
    }

    //KULLANICI LİSTESİ
    const getKullanicilar = async () => {
        const result = await kullanicilar()
        if(result.status===200){
            setKullaniciListesi(result.data)
        }else{
            navigate('/auth/login')  
        }
        
    }

    const [kullaniciListesi, setKullaniciListesi] = useState()
    useEffect(() => {
        document.title = "Dönem İşlemleri"
        getKullanicilar()
        //eslint-disable-next-line
    }, []);







    return (
        <main className='text-slate-500 text-sm'>
            <ToastContainer />
            <div className="py-5">
                <div className="w-full px-4 sm:px-6 md:px-8">
                    <div className='container mx-auto'>
                        <h1 className='page-title leading-6 font-normal text-lg mb-6 text-slate-500 '>Yetkili Kullanıcı İşlemleri</h1>
                    </div>

                    <div className='container mx-auto mb-6'>
                        <div className="bg-slate-100  w-full p-4 rounded-tl-lg rounded-lg flex flex-col gap-y-4">
                            <div className='flex items-center justify-between gap-x-4'>
                                <div className='flex-1 shrink-0 basis-0'>
                                    <input onChange={(e) => { setAdSoyad(e.target.value) }} value={adSoyad} id='adSoyad' type='text' placeholder='Adı Soyadı' className='w-full 0  text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                </div>
                                <div className='flex justify-between items-center space-x-3'>
                                    <button onClick={handleValidation} className='w-full text-xs h-10 text-white bg-slate-500   hover:bg-slate-500/80 leading-5 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                        {formDurum ? 'DÜZENLE' : 'KAYDET'}
                                    </button>
                                    <button onClick={clearForm} className='w-full text-xs h-10 text-slate-500 bg-slate-300 hover:bg-slate-300/80 leading-5 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                        İPTAL
                                    </button>
                                </div>
                            </div>
                            <div className='flex flex-col md:flex-row justify-between items-center gap-x-3 '>
                                <div className='w-full md:w-1/2'>
                                    <input onChange={(e) => { setEposta(e.target.value) }} value={eposta} id='eposta' placeholder='E-Posta' type='text' className='w-full 0  text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                </div>
                                <div className='w-full md:w-1/2'>
                                    <input onChange={(e) => { setTelefon(e.target.value) }} value={telefon} id='telefon' placeholder='Telefon' type='text' className='w-full 0  text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                </div>
                                {/* <div className='w-full md:w-1/3'>
                                    <input onChange={(e) => { setRole(e.target.value) }} value={role} id='role' placeholder='Rol' type='text' className='w-full 0  text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                </div> */}
                            </div>

                        </div>
                    </div>


                    <div className='container mx-auto'>
                        {/* min-h-[calc(100vh_-_200px)] */}
                        <div className="flex flex-wrap relative gap-y-2">
                            <div className="bg-white  w-full p-6 rounded-lg">
                                <div>
                                    <div>
                                        <div className='flex items-center gap-x-3 mb-4'>
                                            <BsFillCalendarWeekFill className='text-xl text-[#b09c73]' />
                                            <p>Dönem Listesi Listesi</p>
                                        </div>
                                        {
                                            kullaniciListesi ? (
                                                <>
                                                    <div className='overflow-x-auto rounded-lg border '>
                                                        <table className='min-w-full  rounded divide-y divide-slate-600  overflow-y-auto'>
                                                            <thead className='border-b border-b-slate-300'>
                                                                <tr>
                                                                    <th className='px-4 py-2 text-left'>#</th>
                                                                    <th className='px-4 py-2 text-left'>Adı Soyadı</th>
                                                                    <th className='px-4 py-2 text-left'>E-Posta</th>
                                                                    <th className='px-4 py-2 text-left'>Telefon</th>
                                                                    <th className='px-4 py-2 text-left'>İşlemler</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="bg-white divide-y divide-slate-200 ">
                                                                {

                                                                    kullaniciListesi && (
                                                                        kullaniciListesi.map((item, key) => (
                                                                            <tr key={key}>
                                                                                <td className='px-4 py-2 text-sm font-medium whitespace-nowrap'>{item.userId}</td>
                                                                                <td className='px-4 py-2 text-sm font-medium whitespace-nowrap'>{item.AdSoyad}</td>
                                                                                <td className='px-4 py-2 text-sm whitespace-nowrap'>{item.email}</td>
                                                                                <td className='px-4 py-2 text-sm whitespace-nowrap'>{item.dahili}</td>
                                                                                <td className='px-4 py-2 text-sm whitespace-nowrap'>{item.role}</td>
                                                                                <td className='px-4 py-2 text-sm whitespace-nowrap space-x-2'>
                                                                                    <button onClick={() => {
                                                                                        setOpen(true)
                                                                                        setUserId(item.userId)
                                                                                    }
                                                                                    }
                                                                                        className='text-xs h-8 text-white bg-red-500 border-transparent border hover:border-red-400 hover:bg-red-500/80 leading-3 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300 transition-all'>
                                                                                        Sil
                                                                                    </button>
                                                                                    <button onClick={() => getKullaniciData(item.userId)} className='text-xs h-8 text-white bg-slate-500 border-transparent border hover:border-slate-400 hover:bg-slate-500/80 leading-3 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                                                        Düzenle
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="mb-4 flex items-center gap-2">
                                                        <div className="bg-red-500 h-2 w-2 shrink-0 rounded-full"></div>
                                                        <h3 className="text-slate-500  font-sans text-sm">Kayıtlı Kulanıcı Bulunmamaktadır.</h3>
                                                    </div>
                                                </>
                                            )
                                        }


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {/* MODAL -------------------------------------------------- */}
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                        <button
                                            type="button"
                                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 "
                                            onClick={() => setOpen(false)}
                                        >
                                            <span className="sr-only">Close</span>
                                            <BsXLg className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <BsFillExclamationTriangleFill className="h-6 w-6 text-red-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                                UYARI!
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    Dönemi silmek üzeresiniz. Emin misiniz?
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                            onClick={() => handleKullaniciDelete()}
                                        >
                                            Evet
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            onClick={() => setOpen(false)}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </main>



    );
}

export default KullaniciIslemleri;
